import { create } from 'zustand';

// Cross-panel "lens" for a Roll-Up Foundation combine, broadcast to the panel's
// CHANNEL (same key as catchment-link — see useCatchmentKey). Two consumers:
//   • the Map renders the member sites as a coverage pin layer;
//   • the Consolidators panel offers to focus white-space on the combine's
//     subsegment.
// The combined-catchment POLYGON rides catchment-link (Census reads that); this
// carries the categorical + point lens that a polygon can't. Small dedicated
// store (not the persisted app store) so a large point set never hits localStorage.

export interface RollupPoint {
  lat: number;
  lng: number;
  name: string | null;
  synthetic: boolean;
  /** Member's own subsegment — each member's catchment + competitors are
   *  computed in its OWN subsegment (a foundation may mix subsegments). */
  subsegment: string | null;
  /** Registry entity id; null for synthetic (off-market) members. */
  entityId: string | null;
}

export interface ActiveRollup {
  points: RollupPoint[];
  /** Primary subsegment of the combine (drives the Consolidators white-space focus). */
  subsegment: string | null;
  /** Primary country (GB/FR). */
  country: string | null;
  label: string;
}

interface RollupLinkState {
  byKey: Record<string, ActiveRollup | null>;
  setFor: (key: string, v: ActiveRollup | null) => void;
}

export const useRollupLink = create<RollupLinkState>((set) => ({
  byKey: {},
  setFor: (key, v) => set((s) => ({ byKey: { ...s.byKey, [key]: v } })),
}));
